<form [formGroup]="form" *appLoader="!form">
  <app-dialog-container
    title="{{ 'useMedicine' | translate }}"
    [isValid]="false"
    (confirmButtonHandler)="save()"
    [form]="form"
  >
    @if (data.stockBatches.length) {
      <div class="batch-use-grid batch-use-grid--header">
        <span>{{ 'expiry' | translate }}</span>
        <span>{{ 'currentQuantity' | translate }}</span>
        <span>{{ 'amount' | translate }}</span>
      </div>
      @for (
        batchForm of form.batches.controls;
        track batchForm.controls.medicineStockBatchId.value;
        let index = $index
      ) {
        <div class="batch-use-grid">
          <span>
            {{
              data.stockBatches[index].expires
                ? (data.stockBatches[index].expires | date)
                : ('noExpiry' | translate)
            }}
          </span>
          <span>{{ data.stockBatches[index].quantity }}</span>
          <app-ui-input
            [control]="batchForm.controls.amount"
            type="number"
            min="0"
            [max]="data.stockBatches[index].quantity"
            [required]="false"
            [ariaLabel]="getBatchAmountAriaLabel(index)"
          ></app-ui-input>
        </div>
      }
      <div class="batch-use-total">
        <span>{{ 'totalAmountToUse' | translate }}:</span>
        <strong>{{ totalAmount }}</strong>
      </div>
    } @else {
      <div class="empty-stock-message">{{ 'noAvailableStockBatches' | translate }}</div>
    }
    <app-ui-text-area
      [label]="'reasonForUse' | translate"
      [control]="form.reason"
      [required]="true"
    ></app-ui-text-area>
  </app-dialog-container>
</form>
